import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "1c4e0748-c1c4-42c6-9b1e-d30ffcf6b1e2",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "Input the physical length of the tube rounded to the nearest integer:",
    suffixText: "cm",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 17,
};
